// ** Util Imports
import { hexToRGBA } from "src/@core/utils/hex-to-rgba";

const Chip = (theme) => {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontSize: "0.75rem",
          height: 26,
          borderRadius: 6,
        },
        filled: {
          "&.MuiChip-colorDefault": {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.text.secondary,
          },
        },
        outlined: {
          "&.MuiChip-colorDefault": {
            borderColor: theme.palette.customColors?.border || theme.palette.divider,
            color: theme.palette.text.secondary,
          },
        },
        deleteIcon: {
          width: 16,
          height: 16,
        },
        avatar: {
          color: theme.palette.text.primary,
        },
        iconColorDefault: {
          color: theme.palette.text.secondary,
        },
        deletableColorPrimary: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.primary.main, 0.7),
            "&:hover": {
              color: theme.palette.primary.main,
            },
          },
        },
        deletableColorSecondary: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.secondary.main, 0.7),
            "&:hover": {
              color: theme.palette.secondary.main,
            },
          },
        },
        deletableColorSuccess: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.success.main, 0.7),
            "&:hover": {
              color: theme.palette.success.main,
            },
          },
        },
        deletableColorError: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.error.main, 0.7),
            "&:hover": {
              color: theme.palette.error.main,
            },
          },
        },
        deletableColorWarning: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.warning.main, 0.7),
            "&:hover": {
              color: theme.palette.warning.main,
            },
          },
        },
        deletableColorInfo: {
          "&.MuiChip-light .MuiChip-deleteIcon": {
            color: hexToRGBA(theme.palette.info.main, 0.7),
            "&:hover": {
              color: theme.palette.info.main,
            },
          },
        },
      },
    },
  };
};

export default Chip;
